import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  MANAGE_CONTACTS_PATH,
  MANAGE_COMMENTS_PATH,
  MANAGE_EXTERNAL_LINKS_PATH,
} from '../../config/routes'

const AdminNavBar = () => {
  const { t } = useTranslation()

  return (
    <Navbar
      className="standard-background navbar-dark-text"
      style={{ marginTop: '10px' }}
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <NavLink
            to={MANAGE_CONTACTS_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_CONTACTS_TITLE')}
          </NavLink>
          <NavLink
            to={MANAGE_COMMENTS_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_COMMENTS_TITLE')}
          </NavLink>
          <NavLink
            to={MANAGE_EXTERNAL_LINKS_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_EXTERNAL_LINKS_TITLE')}
          </NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default AdminNavBar
